import React, { useCallback, useState } from 'react'
import { useMatchBreakpointsContext } from '@pancakeswap/uikit'
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import { Currency, CurrencyAmount, Pair, Percent, Token, TokenAmount } from '@magikswap/sdk'

import RemoveLiquidity from './RemoveLiquidityFunction';

interface RemoveLiquidityModalProps {
  onDismiss: () => void;
  currencyA: Currency | null | undefined;
  currencyB: Currency | null | undefined;
  totalUSDValue: number;
  poolTokenPercentage: Percent;
  tokenADeposited: any
  tokenBDeposited: any
  userPoolBalance: TokenAmount
}


const RemoveLiquidityModal: React.FC<RemoveLiquidityModalProps> = ({ onDismiss, currencyA, currencyB, totalUSDValue, poolTokenPercentage, tokenADeposited, tokenBDeposited, userPoolBalance }) => {
  const { isDesktop } = useMatchBreakpointsContext()
  return (
    <Rodal
      visible={true} closeonEsc={true}
      width={isDesktop ? '600' : '350'} height={isDesktop ? '550' : '590'}
      // height={isDesktop? '1200' : '425' }
      onClose={onDismiss}
      animation="rotate"
      customStyles={{
        backgroundColor: '#000',
        borderRadius: '24px',
        boxShadow: '0 0 3px -1px #ccc, 0 0px 96px #37c0df',
        bottom: 'auto', top: '50%', transform: 'translateY(-50%)'
      }}
    >

      <RemoveLiquidity
        currencyA={currencyA}
        currencyB={currencyB}
        totalUSDValue={totalUSDValue}
        poolTokenPercentage={poolTokenPercentage}
        tokenADeposited={tokenADeposited}
        tokenBDeposited={tokenBDeposited}
        userPoolBalance={userPoolBalance} />
    </Rodal>

  )
}

export default RemoveLiquidityModal
